import BusinessCaseProduct from './business-case-product';

export default BusinessCaseProduct;
